import * as React from "react";

import { InitialProps, createStore } from "../../store";
import { App } from "../../components/App";

export const DateTimePickerApp = (props: InitialProps) => {
  createStore(props);
  return <App />;
};
